import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

import { Box, Flex } from 'Components/Base';
import Loading from 'Components/Loading';

import { getStatusType } from '../utils';

import { TextSubTitle, TextDescription } from './TextContent';

const StatusCard = ({ title, status, loading }) => {
  const { colors } = useTheme();

  const { text, icon: StatusIcon, color } = getStatusType(status);

  return (
    <Flex style={{ boxShadow: '0 2px 4px 0px rgba(0, 0, 0, 0.1)' }}>
      <Box
        px="2px"
        style={{
          background: loading ? colors?.bsGrays.gray300 : colors?.[color],
          borderRadius: '6px 0px 0px 6px',
        }}
      />
      <Flex
        flexGrow={1}
        px={6}
        py={4}
        flexDirection="row"
        style={{
          background: colors?.white,
          borderRadius: '0px 6px 6px 0px',
        }}
      >
        <Box flex={1}>
          <TextSubTitle>{title}</TextSubTitle>
          <TextDescription>{loading ? '-' : text}</TextDescription>
        </Box>
        {loading ? (
          <Box>
            <Loading />
          </Box>
        ) : (
          <StatusIcon />
        )}
      </Flex>
    </Flex>
  );
};

StatusCard.propTypes = {
  title: PropTypes.string,
  status: PropTypes.string,
  loading: PropTypes.bool,
};

export default StatusCard;
